module.exports = {
  colors: {
    current: "currentColor",
    "Primary-900": "#401d6e",
    "Primary-800": "#5b2580",
    "Primary-700": "#6b2a89",
    "Primary-600": "#7c3092",
    "Primary-500": "#883499",
    "Primary-400": "#994da8",
    "Primary-300": "#ab6ab7",
    "Primary-200": "#c393cc",
    "Primary-100": "#f0e5f2",
    "Primary-50": "#ece8f6",
    "Secondary-300": "#ff7d31",
    "Secondary-200": "#ffe48f",
    "Secondary-100": "#ffeebb",
    "Secondary-50": "#fff9e4",
    SP2: "#ff7b31",
    SP1: "#fedd03",
    SP3: "#3dcfff",
    SP4: "#ed3e42",
    SP5: "#ed3e42",
    SP6: "#883499",
    SP7: "#f2eff6",
    SP8: "#00A9F3",
    Body: "#3d3d3d",
    "Body-Inactive": "#818181",
    "Body-Disabled": "#c9c9c9",
    White: "#ffffff",
    Black: "#000000",
    Green: "#25D816",
    Highlight: "#ffe500",
    Transparent: "rgba(255, 255, 255, 0)",
    Opacity9: "rgba(0, 0, 0, 0.9)",
    Opacity5: "rgba(0, 0, 0, 0.5)",
    // Activity Category Colours
    "Splash Zone": "#49c9f5",
    "Power Teams": "#f15846",
    "Super Sports": "#7c62ab",
    "Globe Trotters": "#87c870",
    "Creative Inventors": "#f1696c",
    "Brain Boosters": "#f99f1b",
    "Zen Masters": "#fae80b",
    // Tear Colours
    "Dark-Theme-Tear-Primary": "#ff5e67",
    "Dark-Theme-Tear-Secondary": "#401d6e",
    "Light-Theme-Tear-Primary": "#fedd03",
    "Light-Theme-Tear-Secondary": "#8549eb",
    "Alternative-Theme-Tear-Primary": "#401d6e",
    "Alternative-Theme-Tear-Secondary": "#ff7d31",
    "White-Theme-Tear-Primary": "#ff73d1",
    "White-Theme-Tear-Secondary": "#401d6e",
    // Hero Gradients
    "Homepage-Hero/Gradient-Start": "#3F1D6E",
    "Homepage-Hero/Gradient-End": "transparent",
    "Secondary-Hero/Gradient-Start": "#401d6e",
    "Secondary-Hero/Gradient-End": "#7c3092",
    // Background Texture Colours
    "Background-Texture-Primary": "#FDEBEB",
    "Primary-Button-Text": "#401d6e",
  },
  fontSize: {
    xs: "0.825rem", // 0.75rem * 1.1
    sm: "0.9625rem", // 0.875rem * 1.1
    base: "1.1rem", // 1rem * 1.1
    lg: "1.2375rem", // 1.125rem * 1.1
    xl: "1.375rem", // 1.25rem * 1.1
    "2xl": "1.65rem", // 1.5rem * 1.1
    "3xl": "2.0625rem", // 1.875rem * 1.1
    "4xl": "2.475rem", // 2.25rem * 1.1
    "5xl": "3.3rem", // 3rem * 1.1
    "6xl": "4.4rem", // 4rem * 1.1
  },
  fontFamily: { primary: "Lexend", secondary: "Lexend" },
  lineHeight: {
    none: "1",
    tight: "1.1", // 1 * 1.1
    snug: "1.375", // 1.25 * 1.1
    normal: "1.65", // 1.5 * 1.1
    relaxed: "1.76", // 1.6 * 1.1
    loose: "2.2", // 2 * 1.1
  },
  boxShadow: {
    Inner: "inset 0px 2px 4px 0px rgba(0,34,66,0.2)",
    Sm: "0px 1px 2px 0px rgba(0,34,66,0.05)",
    Default: "0px 1px 2px 0px rgba(0,34,66,0.06), 0px 1px 3px 0px rgba(0,34,66,0.1)",
    Md: "0px 2px 4px -1px rgba(0,34,66,0.06), 0px 4px 6px -1px rgba(0,34,66,0.1)",
    Lg: "0px 4px 6px -2px rgba(0,34,66,0.05), 0px 10px 15px -3px rgba(0,34,66,0.1)",
    Xl: "0px 10px 10px -5px rgba(0,34,66,0.04), 0px 20px 25px -5px rgba(0,34,66,0.1)",
    "2xl": "0px 25px 50px -12px rgba(0,0,0,0.3)",
  },
  borderRadius: {
    none: "0",
    xs: "0.125rem",
    sm: "0.13320313394069672rem",
    default: "0.18736979365348816rem",
    lg: "0.1875rem",
    xl: "0.25rem",
    "2xl": "0.3125rem",
    "3xl": "0.3747395873069763rem",
    "4xl": "0.375rem",
    "5xl": "0.5rem",
    "6xl": "0.625rem",
    "7xl": "0.6660156846046448rem",
    "8xl": "0.7305389046669006rem",
    full: "9999px",
  },
  screens: {
    sm: "722px" /* 640 ith 16px gutter */,
    md: "900px" /* 768 with 16px gutter */,
    lg: "1160px" /* 1024 with 16px gutter */,
    xl: "1440px" /* 1280 with 80px gutter */,
    "2xl": "1600px" /*1440 with 80px gutter */,
    "3xl": "1920px" /* 1536 with 192px gutter */,
  },
  container: {
    padding: {
      DEFAULT: "16px",
      xl: "80px",
      "2xl": "132px",
    },
  },
  extend: {
    transitionDelay: {
      400: "400ms",
      600: "600ms",
      800: "800ms",
      900: "900ms",
      1100: "1100ms",
      1200: "1200ms",
      1300: "1300ms",
    },
    spacing: {
      "text-xs": "0.55rem", // 0.5rem * 1.1
      "text-sm": "0.66rem", // 0.6rem * 1.1
      "text-base": "0.88rem", // 0.8rem * 1.1
      "text-lg": "1.1rem", // 1rem * 1.1
      "text-xl": "1.32rem", // 1.2rem * 1.1
      "text-2xl": "1.65rem", // 1.5rem * 1.1
      "text-3xl": "2.2rem", // 2rem * 1.1
      "text-4xl": "2.75rem", // 2.5rem * 1.1
      "text-5xl": "3.3rem", // 3rem * 1.1
      "text-6xl": "4.4rem", // 4rem * 1.1
      "osh-p-2.5": "0.625rem", // Custom padding for OSHC only
      "search-bar": "0.67em", // Custom padding for search bar input in OSHC
    },
  },
  variants: {
    fill: ["group-hover", "hover", "focus"],
    textColor: ["responsive", "hover", "focus", "group-hover"],
    scrollbar: ["rounded"],
    boxShadow: ["responsive", "hover", "focus"],
    extend: {
      gridColumnEnd: ["last"],
    },
  },
  safeList: [
    "text-White",
    "text-Highlight",
    "current",
    "fill-current",
    "rotate-180",
    "group-hover:rotate-180",
    "visible",
    "invisible",
    {
      pattern: /text-(Primary|Secondary)-(50|100|200|300|400|500|600|700|800|900)/,
      variants: ["hover", "group-hover"],
    },
    {
      pattern: /fill-(Primary|Secondary)-(50|100|200|300|400|500|600|700|800|900)/,
      variants: ["hover", "group-hover"],
    },
  ],
};
